export interface FilterValues {
   itemNos?: string[];
   itemName?: string;
   search?: string;
   hfbs?: string[];
   pas?: string[];
   buCodePru?: string;
   buCodePdu?: string;
   familyName?: string[];
   itemState?: string;
   part?: string;
   partDetail?: string;
   materialGradeId?: string;
   search2?: string;
   comment?: string;
   updatedBy?: string;
    progressState?: string[];
   piaImportStatus?: string[];
   ssd?: string[];
   eds?: string[];
   locked?: boolean;
   unlocked?: boolean;
   dwpDeviates?: boolean;
   isBase?: boolean;
    excludeConnected?: boolean;
    missingGradeId?: boolean;
    outgoingGradeIds?: boolean;
}

export const ARRAY_FIELDS = ['hfbs', 'pas', 'ssd', 'eds', 'progressState', 'piaImportStatus', 'familyName', 'itemNos'] as const;

export type ArrayField = typeof ARRAY_FIELDS[number];

export const isArrayField = (key: string): key is ArrayField => ARRAY_FIELDS.includes(key as ArrayField);

export interface LockedStates {
   locked: boolean;
   unlocked: boolean;
   dwpDeviates: boolean;
   isBase: boolean;
    excludeConnected: boolean;
    missingGradeId: boolean;
    outgoingGradeIds: boolean;
}
